module.exports = __webpack_public_path__ + "static/media/edit.ce76cb29.svg";